import { AiOutlineControl, AiOutlineQuestionCircle } from "react-icons/ai"
import { Link, useNavigate } from "react-router-dom"
import Select from 'react-select';
import { brandOptions, productStatusOptions } from "../../constants/enum";
import { useContext, useState } from "react";
import ProductContext from "../../contexts/ProductContext";
import TabMedia from "./tabMedia";

import { useForm, SubmitHandler, Controller, FormProvider } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import ModalConfirm from "../../components/ModalConfirm";
import { API, graphqlOperation } from "aws-amplify";
import { updateProductLibProduct } from "../../graphql/mutations";

interface IFormInputs {
  titleTH: string,
  titleEN: string,
  name: string,
  materialCode: string,
  productHierachy: string,
  barcode: string,
  brand: { value?: string; label?: string },
  brandType: string,
  status: { value?: string; label?: string },
  packaging: string,
  category: string,
  subcategory: string,
  collection: string,
  color: string,
  functions: string,
  // description: string,
  descriptionEN: string,
  descriptionTH: string,
  classifier: string,
  length: string,
  width: string,
  height: string,
  weight: string,
  weightUnit: string,
}

const ProductSchema: any = yup.object({
  titleTH: yup.string().defined(),
  titleEN: yup.string().defined(),
  name: yup.string().defined().required('materialName is a required field'),
  materialCode: yup.string().defined().required(),
  productHierachy: yup.string().defined().required(),
  barcode: yup.string().defined().required(),
  brand: yup
      .object()
      .shape({
        value: yup.string().required(),
        label: yup.string().required(),
      })
      .required(),
  brandType: yup.string().required(),
  status: yup
      .object()
      .shape({
        value: yup.string().required(),
        label: yup.string().required(),
      })
      .required(),
  packaging: yup.string().defined().required(),
  category: yup.string(),
  subcategory: yup.string(),
  collection: yup.string(),
  color: yup.string(),
  // functions: yup.array().of(yup.string()),
  // description: yup.string(),
  // descriptionEN: yup.string(),
  // descriptionTH: yup.string(),
  classifier: yup.string().defined().required(),
  length: yup.string().defined().required(),
  width: yup.string().defined().required(),
  height: yup.string().defined().required(),
  weight: yup.string().defined().required(),
  weightUnit: yup.string().defined().required(),
})

function EditProduct() {

  const navigate = useNavigate();
  const { product } = useContext(ProductContext);
  const productInfo: any = product;
  const [ submitShowDialog, setSubmitShowDialog ] = useState<boolean>(false)
  const [ isLoading, setIsLoading ] = useState<boolean>(false) 
  
  const isCantEditable = true
  const defaultBrand = brandOptions.find(brand => brand.value === productInfo.brand)
  const defaultStatus = productStatusOptions.find(status => status.value === productInfo.status)
  const methods = useForm<IFormInputs>({
    defaultValues: {
      titleTH: productInfo.titleTH,
      titleEN: productInfo.titleEN,
      name: productInfo.name,
      materialCode: productInfo.materialCode,
      productHierachy: productInfo.productHierachy,
      barcode: productInfo.barcode,
      brand: { label: defaultBrand?.label, value: productInfo.brand },
      brandType: productInfo.brandType,
      status: { label: defaultStatus?.label, value: productInfo.status },
      packaging: productInfo.packaging,
      category: productInfo.category,
      subcategory: productInfo.subcategory,
      collection: productInfo.collection,
      color: productInfo.color,
      functions: productInfo.functions,
      // description: productInfo.description,
      descriptionEN: productInfo.descriptionEN,
      descriptionTH: productInfo.descriptionTH,
      classifier: productInfo.classifier,
      length: productInfo.length,
      width: productInfo.width,
      height: productInfo.height,
      weight: productInfo.weight,
      weightUnit: productInfo.weightUnit,
    },
    resolver: yupResolver(ProductSchema)
  })

  const { 
    register, handleSubmit, control, getValues,
    formState : { errors, isSubmitting }
  } = methods

  const onSubmitForm: SubmitHandler<IFormInputs> = async (data) => {
    console.log(data)
    setSubmitShowDialog(true)
  }

  /* Need to have variable below for validate error */
  const onInvalid = (errors:any) => console.error(errors)

  const currentDate = new Date();
  const formatDate = (date: Date): string => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  const submitProductDetail = async () => {
    const dataForm = getValues()
    console.log("dataForm : ", dataForm)

    const functions = Array.isArray(dataForm.functions) ? JSON.stringify(dataForm.functions) : JSON.stringify(dataForm.functions.split(','))
    const editProductInput = {
      id: productInfo.id,
      status: dataForm.status.value,
      titleTH: dataForm.titleTH,
      titleEN: dataForm.titleEN,
      name: dataForm.name,
      materialCode: dataForm.materialCode,
      productHierachy: dataForm.productHierachy,
      barcode: dataForm.barcode,
      brand: dataForm.brand.value,
      brandType: dataForm.brandType,
      packaging: dataForm.packaging,
      category: dataForm.category,
      subcategory: dataForm.subcategory,
      collection: dataForm.collection,
      color: dataForm.color,
      functions: functions,
      // description: dataForm.description,
      descriptionEN: dataForm.descriptionEN,
      descriptionTH: dataForm.descriptionTH,
      classifier: dataForm.classifier,
      length: dataForm.length,
      width: dataForm.width,
      height: dataForm.height,
      weight: dataForm.weight,
      weightUnit: dataForm.weightUnit,
      lastUpdatedDate: formatDate(currentDate),
    };

    console.log("editProductInput : ",editProductInput)

    const editProductResponse: any = await API.graphql(
      graphqlOperation(updateProductLibProduct, {
        input: { ...editProductInput },
      })
    );
    console.log("editProductResponse : ", editProductResponse)

    setTimeout(() => {
        setIsLoading(false)
        setSubmitShowDialog(false)
    }, 2000);
  }

  return <>
    <div>
      <ul
        className="flex flex-col flex-wrap justify-center pl-0 mt-2 mb-1 list-none border-b-0 md:flex-row"
        role="tablist"
        data-te-nav-ref>
        <li role="presentation">
          <a
            href="/"
            className="my-2 block border-x-0 border-t-0 border-b-2 border-transparent px-7 pt-4 pb-3.5 text-xs font-medium uppercase leading-tight text-neutral-500 hover:isolate hover:border-transparent hover:bg-neutral-100 focus:isolate focus:border-transparent data-[te-nav-active]:border-violet data-[te-nav-active]:text-violet dark:text-neutral-400 dark:hover:bg-transparent data-[te-nav-active]:border-violet-400 data-[te-nav-active]:text-violet-400"
            data-te-toggle="pill"
            data-te-target="#tabs-sync-product"
            data-te-nav-active
            role="tab"
            aria-controls="tabs-sync-product"
            aria-selected="true"
            >
              <div className='flex items-center gap-2'>
                <AiOutlineControl size={20}/><span className=''>Control Panel</span>
              </div>
          </a>
        </li>
      </ul>

      <div className="mb-1">
        <div
          className="hidden opacity-100 transition-opacity duration-150 ease-linear data-[te-tab-active]:block"
          id="tabs-sync-product"
          role="tabpanel"
          aria-labelledby="tabs-sync-product-tab"
          data-te-tab-active
        >
          <div className="mb-6 px-6">
            <div className="page-container-title">
              <div className="grid grid-cols-5 gap-0.5 md:gap-1 items-center sm:page-container-only-button">
                <p className="font-bold text-lg mr-2 col-start-1 col-end-3">Edit product</p>
                <Link to={`/controlPanel`} className={' text-violet-400 hover:text-violet-600 text-xs col-start-3 col-end-5'}>
                {'<<'}  Back to control panel
                </Link>
              </div>
            </div>

            
            <ul
              className="nav nav-tabs flex flex-col md:flex-row flex-wrap list-none border-b-0 pl-0 my-2"
              role="tablist"
              data-te-nav-ref>
              <li role="presentation">
                <a
                  href="#tabs-info"
                  className="my-2 block border-x-0 border-t-0 border-b-2 border-transparent px-7 py-3 text-xs font-medium uppercase leading-tight text-neutral-500 hover:isolate hover:border-transparent hover:bg-neutral-100 focus:isolate focus:border-transparent data-[te-nav-active]:border-emerald data-[te-nav-active]:text-emerald dark:text-neutral-400 dark:hover:bg-transparent data-[te-nav-active]:border-emerald-400 data-[te-nav-active]:text-emerald-400"
                  data-te-toggle="pill"
                  data-te-target="#tabs-info"
                  data-te-nav-active
                  role="tab"
                  aria-controls="tabs-info"
                  aria-selected="true"
                  >
                    <div className='flex items-center gap-2'>
                      <span className=''>
                        {
                          errors.titleTH ||
                          errors.titleEN ||
                          errors.name ||
                          errors.materialCode ||
                          errors.productHierachy ||
                          errors.barcode ||
                          errors.brandType ||
                          errors.packaging ||
                          errors.category ||
                          errors.subcategory ||
                          errors.collection ||
                          errors.color ||
                          errors.functions ||
                          // errors.description ||
                          errors.descriptionEN ||
                          errors.descriptionTH ?
                            <label className='text-red-500 text-md font-bold'>INFO *</label> :
                            "INFO"
                        }
                      </span>
                    </div>
                </a>
              </li>
              <li role="presentation">
                <a
                  href="#tabs-dimension"
                  className="focus:border-transparen my-2 block border-x-0 border-t-0 border-b-2 border-transparent px-7 py-3 text-xs font-medium uppercase leading-tight text-neutral-500 hover:isolate hover:border-transparent er hover:bg-neutral-100 focus:isolate data-[te-nav-active]:border-primary data-[te-nav-active]:text-primary dark:text-neutral-400 dark:hover:bg-transparent dark:data-[te-nav-active]:border-primary-400 dark:data-[te-nav-active]:text-primary-400"
                  data-te-toggle="pill"
                  data-te-target="#tabs-dimension"
                  role="tab"
                  aria-controls="tabs-dimension"
                  aria-selected="false"
                  >
                    <div className='flex flex-row items-center gap-2'>
                      <span className=''>
                        {
                          errors.classifier ||
                          errors.length ||
                          errors.width ||
                          errors.height ||
                          errors.weight ||
                          errors.weightUnit ?
                            <label className='text-red-500 text-md font-bold'>Dimension *</label> :
                            "Dimension"
                        }
                      </span>
                    </div>
                </a>
              </li>
              <li role="presentation">
                <a
                  href="#tabs-media"
                  className="focus:border-transparen my-2 block border-x-0 border-t-0 border-b-2 border-transparent px-7 py-3 text-xs font-medium uppercase leading-tight text-neutral-500 hover:isolate hover:border-transparent hover:bg-neutral-100 focus:isolate data-[te-nav-active]:border-orange-400 data-[te-nav-active]:text-orange-400 dark:text-neutral-400 dark:hover:bg-transparent dark:data-[te-nav-active]:border-orange-400 dark:data-[te-nav-active]:text-orange-400"
                  data-te-toggle="pill"
                  data-te-target="#tabs-media"
                  role="tab"
                  aria-controls="tabs-media"
                  aria-selected="false"
                  >
                    <div className='flex items-center gap-2'>
                      <span className=''>Media</span>
                    </div>
                </a>
              </li>
            </ul>


            <FormProvider {...methods}>
              <form className="w-full" onSubmit={handleSubmit(onSubmitForm, onInvalid)}>

                {/* Tab INFO */}
                <div
                  className="hidden opacity-100 transition-opacity duration-150 ease-linear data-[te-tab-active]:block"
                  id="tabs-info"
                  role="tabpanel"
                  aria-labelledby="tabs-info-tab"
                  data-te-tab-active
                >
                  {/* Section >> Title TH, Title EN */}
                  <div className="flex flex-wrap -mx-3 mb-6">
                    <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-first-name">
                        Title TH
                      </label>
                      <input disabled={isCantEditable} className="form-input-control-panel-2" id="grid-first-name" type="text" placeholder="Jane" { ...register('titleTH')} />
                      {errors.titleTH ? <small className='font-light text-red-500'>{errors.titleTH.message}</small> : ""}
                    </div>
                    <div className="w-full md:w-1/2 px-3">
                      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-last-name">
                        Title EN
                      </label>
                      <input disabled={isCantEditable} className="form-input-control-panel-2" id="grid-last-name" type="text" placeholder="Doe" { ...register('titleEN')} />
                      {errors.titleEN ? <small className='font-light text-red-500'>{errors.titleEN.message}</small> : ""}
                    </div>
                  </div>

                  {/* Section >> MaterialCode, Name, ProductHierachy, Barcode */}
                  <div className="flex flex-wrap -mx-3 mb-6">
                    <div className="w-full xs:w-1/2 md:w-1/4 px-3 mb-6 md:mb-0">
                      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-material-name">
                        material name
                      </label>
                      <input disabled={isCantEditable} className="form-input-control-panel-2" id="grid-material-name" type="text" placeholder="material-name" { ...register('name')} />
                      {errors.name ? <small className='font-light text-red-500'>{errors.name.message}</small> : ""}
                    </div>
                    <div className="w-full xs:w-1/2 md:w-1/4 px-3 mb-6 md:mb-0">
                      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-material-code">
                        material code
                      </label>
                      <input disabled={isCantEditable} className="form-input-control-panel-2" id="grid-material-code" type="text" placeholder="material-code" { ...register('materialCode')} />
                      {errors.materialCode ? <small className='font-light text-red-500'>{errors.materialCode.message}</small> : ""}
                    </div>
                    <div className="w-full xs:w-1/2 md:w-1/4 px-3">
                      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-product-hierachy">
                        product hierachy
                      </label>
                      <input disabled={isCantEditable} className="form-input-control-panel-2" id="grid-product-hierachy" type="text" placeholder="product-hierachy" { ...register('productHierachy')} />
                      {errors.productHierachy ? <small className='font-light text-red-500'>{errors.productHierachy.message}</small> : ""}
                    </div>
                    <div className="w-full xs:w-1/2 md:w-1/4 px-3">
                      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-barcode">
                        barcode
                      </label>
                      <input disabled={isCantEditable} className="form-input-control-panel-2" id="grid-barcode" type="text" placeholder="barcode" { ...register('barcode')} />
                      {errors.barcode ? <small className='font-light text-red-500'>{errors.barcode.message}</small> : ""}
                    </div>
                  </div>

                  {/* Section >> Brand, Brand-Type, Status, Packaging */}
                  <div className="flex flex-wrap -mx-3 mb-6">
                    <div className="w-full xs:w-1/2 md:w-1/4 px-3 mb-6 md:mb-0">
                      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-first-name">
                        Brand
                      </label>
                      <Controller
                        name="brand"
                        control={control}
                        render={({ field }) => <Select
                          {...field}
                          className="basic-single font-normal text-sm"
                          classNamePrefix="select"
                          placeholder="เลือก brand"
                          isSearchable={true}
                          isClearable={false}
                          isDisabled={isCantEditable}
                          options={brandOptions as any}
                        />}
                      />
                    </div>
                    <div className="w-full xs:w-1/2 md:w-1/4 px-3 mb-6 md:mb-0">
                      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-brand-type">
                        Brand Type
                      </label>
                      <input disabled={isCantEditable} className="form-input-control-panel-2" id="grid-brand-type" type="text" placeholder="brand-type" { ...register('brandType')} />
                      {errors.brandType ? <small className='font-light text-red-500'>{errors.brandType.message}</small> : ""}
                    </div>
                    <div className="w-full xs:w-1/2 md:w-1/4 px-3">
                      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-status">
                        Status
                      </label>
                      <Controller
                        name="status"
                        control={control}
                        render={({ field }) => <Select
                          {...field}
                          className="basic-single font-normal text-sm"
                          classNamePrefix="select"
                          placeholder="เลือก status"
                          isSearchable={true}
                          isClearable={false}
                          isDisabled={isCantEditable}
                          options={productStatusOptions as any}
                        />}
                      />
                    </div>
                    <div className="w-full xs:w-1/2 md:w-1/4 px-3">
                      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-last-name">
                        Packaging
                      </label>
                      <input disabled={isCantEditable} className="form-input-control-panel-2" id="grid-last-name" type="text" placeholder="EA" { ...register('packaging')} />
                      {errors.packaging ? <small className='font-light text-red-500'>{errors.packaging.message}</small> : ""}
                    </div>
                  </div>

                  {/* Section >> Category, Subcategory, Collection, Color */}
                  <div className="flex flex-wrap -mx-3 mb-6">
                    <div className="w-full xs:w-1/2 md:w-1/4 px-3 mb-6 md:mb-0">
                      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-category">
                        category
                      </label>
                      <input disabled={isSubmitting} className="form-input-control-panel-2" id="grid-category" type="text" placeholder="category" { ...register('category')} />
                      {errors.category ? <small className='font-light text-red-500'>{errors.category.message}</small> : ""}
                    </div>
                    <div className="w-full xs:w-1/2 md:w-1/4 px-3 mb-6 md:mb-0">
                      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-subcategory">
                        subcategory
                      </label>
                      <input disabled={isSubmitting} className="form-input-control-panel-2" id="grid-subcategory" type="text" placeholder="subcategory" { ...register('subcategory')} />
                      {errors.subcategory ? <small className='font-light text-red-500'>{errors.subcategory.message}</small> : ""}
                    </div>
                    <div className="w-full xs:w-1/2 md:w-1/4 px-3">
                      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-collection">
                        collection
                      </label>
                      <input disabled={isSubmitting} className="form-input-control-panel-2" id="grid-collection" type="text" placeholder="collection" { ...register('collection')} />
                      {errors.collection ? <small className='font-light text-red-500'>{errors.collection.message}</small> : ""}
                    </div>
                    <div className="w-full xs:w-1/2 md:w-1/4 px-3">
                      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-color">
                        color
                      </label>
                      <input disabled={isSubmitting} className="form-input-control-panel-2" id="grid-color" type="text" placeholder="color" { ...register('color')} />
                      {errors.color ? <small className='font-light text-red-500'>{errors.color.message}</small> : ""}
                    </div>
                  </div>

                  {/* Section >> Description */}
                  <div className="flex flex-wrap -mx-3 mb-6">
                    {/* <div className="w-full md:w-1/2 px-3">
                      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-description">
                        Description
                      </label>
                      <textarea disabled={isSubmitting} className="form-input-control-panel-2" id="grid-description" placeholder="description" { ...register('description')} />
                      {errors.description ? <small className='font-light text-red-500'>{errors.description.message}</small> : ""}
                    </div> */}
                    <div className="w-full md:w-1/2 px-3">
                      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-descriptionTH">
                        Description TH
                      </label>
                      <textarea disabled={isSubmitting} className="form-input-control-panel-2" id="grid-descriptionTH" placeholder="description TH" { ...register('descriptionTH')} />
                      {errors.descriptionTH ? <small className='font-light text-red-500'>{errors.descriptionTH.message}</small> : ""}
                    </div>
                    <div className="w-full md:w-1/2 px-3">
                      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-descriptionEN">
                        Description EN
                      </label>
                      <textarea disabled={isSubmitting} className="form-input-control-panel-2" id="grid-descriptionEN" placeholder="description EN" { ...register('descriptionEN')} />
                      {errors.descriptionEN ? <small className='font-light text-red-500'>{errors.descriptionEN.message}</small> : ""}
                    </div>
                  </div>

                  {/* Section >> Functions */}
                  <div className="flex flex-wrap -mx-3 mb-6">
                    <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                      <span className="flex tracking-wide text-gray-400 text-xs">  
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 mr-2" htmlFor="grid-functions">
                          functions
                        </label>
                        <p>[ex. อาบ,สระ]</p>
                      </span>
                      <textarea disabled={isSubmitting} className="form-input-control-panel-2" id="grid-functions" placeholder="functions" { ...register('functions')} />
                      {errors.functions ? <small className='font-light text-red-500'>{errors.functions.message}</small> : ""}
                    </div>
                  </div>
                </div>

                {/* Tab DIMENSION */}
                <div
                  className="hidden opacity-0 transition-opacity duration-150 ease-linear data-[te-tab-active]:block"
                  id="tabs-dimension"
                  role="tabpanel"
                  aria-labelledby="tabs-dimension-tab"
                >
                  {/* Section >> Classifier, Length, Width, Height, Weight, WeightUnit */}
                  <div className="flex flex-wrap -mx-3 mb-6">
                    <div className="w-full xs:w-1/2 md:w-1/3 px-3 mb-6">
                      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-classifier">
                        classifier
                      </label>
                      <input disabled={isCantEditable} className="form-input-control-panel-2" id="grid-classifier" type="text" placeholder="classifier" { ...register('classifier')} />
                      {errors.classifier ? <small className='font-light text-red-500'>{errors.classifier.message}</small> : ""}
                    </div>
                    <div className="w-full xs:w-1/2 md:w-1/3 px-3 mb-6">
                      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-length">
                        length
                      </label>
                      <input disabled={isCantEditable} className="form-input-control-panel-2" id="grid-length" type="text" placeholder="length" { ...register('length')} />
                      {errors.length ? <small className='font-light text-red-500'>{errors.length.message}</small> : ""}
                    </div>
                    <div className="w-full xs:w-1/2 md:w-1/3 px-3 mb-6">
                      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-width">
                        width
                      </label>
                      <input disabled={isCantEditable} className="form-input-control-panel-2" id="grid-width" type="text" placeholder="width" { ...register('width')} />
                      {errors.width ? <small className='font-light text-red-500'>{errors.width.message}</small> : ""}
                    </div>
                    <div className="w-full xs:w-1/2 md:w-1/3 px-3">
                      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-height">
                        height
                      </label>
                      <input disabled={isCantEditable} className="form-input-control-panel-2" id="grid-height" type="text" placeholder="height" { ...register('height')} />
                      {errors.height ? <small className='font-light text-red-500'>{errors.height.message}</small> : ""}
                    </div>
                    <div className="w-full xs:w-1/2 md:w-1/3 px-3">
                      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-weight">
                        weight
                      </label>
                      <input disabled={isCantEditable} className="form-input-control-panel-2" id="grid-weight" type="text" placeholder="weight" { ...register('weight')} />
                      {errors.weight ? <small className='font-light text-red-500'>{errors.weight.message}</small> : ""}
                    </div>
                    <div className="w-full xs:w-1/2 md:w-1/3 px-3">
                      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-weightUnit">
                        Weight Unit
                      </label>
                      <input disabled={isCantEditable} className="form-input-control-panel-2" id="grid-weightUnit" type="text" placeholder="weightUnit" { ...register('weightUnit')} />
                      {errors.weightUnit ? <small className='font-light text-red-500'>{errors.weightUnit.message}</small> : ""}
                    </div>
                  </div>
                </div>

                {/* Tab MEDIA */}
                <TabMedia product={productInfo}/>


                <div className="flex justify-end gap-2">
                  <button className="btn-back" type="button" disabled={isSubmitting} onClick={() => { navigate(`/controlPanel`) }}>Back</button>
                  <button className="btn-submit" type="submit" disabled={Object.keys(errors).length > 0} onClick={() => setSubmitShowDialog(true)}>Submit</button>
                </div>

              </form>
            </FormProvider>
          </div>
        </div>
      </div>
    </div>
    <ModalConfirm show={submitShowDialog}
      onHide={() => {}}
      title='Submit Confirmation'
      cancelText={'close'}
      cancelAction={() => setSubmitShowDialog(false)}
      okText={'confirm'}
      okAction={() => {
        setIsLoading(true)
        submitProductDetail()
      }}
      okClass='btn-submit'
      loading={isLoading}
      isDisabled={Object.keys(errors).length > 0}
    >
      <div className='flex flex-col items-center justify-center space-y-2 text-center '>
        <AiOutlineQuestionCircle size={48} color={"#a3e635"}/>
        <h6>Do you want to submit edited product detail?</h6>
      </div>
    </ModalConfirm>
  </>
}

export default EditProduct